import React, { VFCX } from 'react';
import styled from '@emotion/styled';
import { AnyImage } from 'src/components';

const Component: VFCX = ({ className }) => (
  <div className={className}>
    <div className='container'>
      <h2>身につけたこと</h2>
      <AnyImage filename='gummy-tv-room.svg' className='background-image' />
    </div>
  </div>
);

const StyledComponent = styled(Component)`
  flex: 2 1 auto;
  background-color: var(--color-secondary-light);
  max-width: 500px;

  & > div {
    height: 100%;
    max-height: 100vh;
    min-width: 400px;
    padding: 2rem 0;
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;

    & > h2 {
      font-weight: 600;
    }

    & img {
      width: 400px;
      height: 400px;
    }
  }
`;

export default StyledComponent;
